export default (hit) => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' }
  const date = new Date(hit.date.date).toLocaleDateString(config.locale, options)

  return `
    <a href="${hit.path}" class="card card-newsroom">
      <picture>
          <source media="(max-width: 420px)" srcset="https://res.cloudinary.com/drfuttoba/image/upload/c_fill,f_auto,q_auto,w_356,h_356/${hit.image.singleMedia.publicId} 1x, https://res.cloudinary.com/drfuttoba/image/upload/c_fill,f_auto,q_auto,w_712,h_712/${hit.image.singleMedia.publicId} 2x"/>
          <source media="(max-width: 767px)" srcset="https://res.cloudinary.com/drfuttoba/image/upload/c_fill,f_auto,q_auto,w_650,h_650/${hit.image.singleMedia.publicId} 1x, https://res.cloudinary.com/drfuttoba/image/upload/c_fill,f_auto,q_auto,w_1300,h_1300/${hit.image.singleMedia.publicId} 2x"/>
          <source media="(max-width: 1279px)" srcset="https://res.cloudinary.com/drfuttoba/image/upload/c_fill,f_auto,q_auto,w_394,h_394/${hit.image.singleMedia.publicId} 1x, https://res.cloudinary.com/drfuttoba/image/upload/c_fill,f_auto,q_auto,w_788,h_788/${hit.image.singleMedia.publicId} 2x"/>
          <source media="(min-width: 1280px)" srcset="https://res.cloudinary.com/drfuttoba/image/upload/c_fill,f_auto,q_auto,w_438,h_438/${hit.image.singleMedia.publicId} 1x, https://res.cloudinary.com/drfuttoba/image/upload/c_fill,f_auto,q_auto,w_876,h_876/${hit.image.singleMedia.publicId} 2x"/>
          <img class="w-full lazyload"
              width="438" height="438"
              src="https://res.cloudinary.com/drfuttoba/image/upload/c_fill,f_auto,q_auto,w_438,h_438/${hit.image.singleMedia.publicId}"
              alt="${hit.image.singleMedia.alt}"/>
      </picture>

      <div class="card-newsroom__infos">
          <p class="font-weight-light card-title mb-2 mt-4 md:my-4">${hit.title}</p>
          <p class="text-14 md:text-base leading-5">${date}</p>
      </div>
    </a>
  `
}
